/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminChangeRewardPointResponse } from '../../src/model';
// @ts-ignore
import type { AdminChangeViewingTypeRewardPointRequestBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminCheckCampaignParticipationStatusInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminCheckCampaignParticipationStatusOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetCampaignUrlBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { AdminGetCampaignUrlInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetCampaignUrlNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetCampaignUrlOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUserViewingHistoryInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUserViewingHistoryOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUserViewingReportInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUserViewingReportOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminViewingApi - axios parameter creator
 * @export
 */
export const AdminViewingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 관리자 뷰잉 포인트 변경 API
         * @param {number} viewingTypeId 
         * @param {AdminChangeViewingTypeRewardPointRequestBodyDto} adminChangeViewingTypeRewardPointRequestBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangeRewardPoint: async (viewingTypeId: number, adminChangeViewingTypeRewardPointRequestBodyDto: AdminChangeViewingTypeRewardPointRequestBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viewingTypeId' is not null or undefined
            assertParamExists('adminChangeRewardPoint', 'viewingTypeId', viewingTypeId)
            // verify required parameter 'adminChangeViewingTypeRewardPointRequestBodyDto' is not null or undefined
            assertParamExists('adminChangeRewardPoint', 'adminChangeViewingTypeRewardPointRequestBodyDto', adminChangeViewingTypeRewardPointRequestBodyDto)
            const localVarPath = `/admin/viewing/change-reward-point/{viewingTypeId}`
                .replace(`{${"viewingTypeId"}}`, encodeURIComponent(String(viewingTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminChangeViewingTypeRewardPointRequestBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 뷰잉하기 캠페인 참여 상태 확인
         * @param {string} campaignUuid 
         * @param {string} snsAccountUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViewingControllerCheckCampaignParticipationStatus: async (campaignUuid: string, snsAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignUuid' is not null or undefined
            assertParamExists('adminViewingControllerCheckCampaignParticipationStatus', 'campaignUuid', campaignUuid)
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('adminViewingControllerCheckCampaignParticipationStatus', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/admin/viewing/campaigns/{campaignUuid}/snsAccounts/{snsAccountUuid}/verify`
                .replace(`{${"campaignUuid"}}`, encodeURIComponent(String(campaignUuid)))
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 뷰잉하기 캠페인 url 조회
         * @param {string} campaignUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViewingControllerGetCampaignUrl: async (campaignUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignUuid' is not null or undefined
            assertParamExists('adminViewingControllerGetCampaignUrl', 'campaignUuid', campaignUuid)
            const localVarPath = `/admin/viewing/campaigns/{campaignUuid}`
                .replace(`{${"campaignUuid"}}`, encodeURIComponent(String(campaignUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 회원 뷰잉하기 내역 조회
         * @param {boolean} isDeleted 삭제된 계정 포함
         * @param {string} [id] 
         * @param {string} [snsId] 
         * @param {string} [orderId] 
         * @param {AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum} [platformCategory] 
         * @param {AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum} [viewingBehavior] 
         * @param {AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum} [viewingCategory] 
         * @param {AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum} [pointFilterType] 
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminViewingControllerGetUserViewingHistorySortOrderEnum} [sortOrder] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViewingControllerGetUserViewingHistory: async (isDeleted: boolean, id?: string, snsId?: string, orderId?: string, platformCategory?: AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum, viewingBehavior?: AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum, viewingCategory?: AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum, pointFilterType?: AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum, page?: number, limit?: number, sortOrder?: AdminViewingControllerGetUserViewingHistorySortOrderEnum, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isDeleted' is not null or undefined
            assertParamExists('adminViewingControllerGetUserViewingHistory', 'isDeleted', isDeleted)
            const localVarPath = `/admin/viewing/user-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (snsId !== undefined) {
                localVarQueryParameter['snsId'] = snsId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (platformCategory !== undefined) {
                localVarQueryParameter['platformCategory'] = platformCategory;
            }

            if (viewingBehavior !== undefined) {
                localVarQueryParameter['viewingBehavior'] = viewingBehavior;
            }

            if (viewingCategory !== undefined) {
                localVarQueryParameter['viewingCategory'] = viewingCategory;
            }

            if (pointFilterType !== undefined) {
                localVarQueryParameter['pointFilterType'] = pointFilterType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['isDeleted'] = isDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 회원 뷰잉하기 포인트 누계 조회
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViewingControllerGetUserViewingReport: async (userId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminViewingControllerGetUserViewingReport', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminViewingControllerGetUserViewingReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('adminViewingControllerGetUserViewingReport', 'endDate', endDate)
            const localVarPath = `/admin/viewing/user-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminViewingApi - functional programming interface
 * @export
 */
export const AdminViewingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminViewingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 관리자 뷰잉 포인트 변경 API
         * @param {number} viewingTypeId 
         * @param {AdminChangeViewingTypeRewardPointRequestBodyDto} adminChangeViewingTypeRewardPointRequestBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminChangeRewardPoint(viewingTypeId: number, adminChangeViewingTypeRewardPointRequestBodyDto: AdminChangeViewingTypeRewardPointRequestBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminChangeRewardPointResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminChangeRewardPoint(viewingTypeId, adminChangeViewingTypeRewardPointRequestBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminViewingApi.adminChangeRewardPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 뷰잉하기 캠페인 참여 상태 확인
         * @param {string} campaignUuid 
         * @param {string} snsAccountUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminViewingControllerCheckCampaignParticipationStatus(campaignUuid: string, snsAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCheckCampaignParticipationStatusOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminViewingControllerCheckCampaignParticipationStatus(campaignUuid, snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminViewingApi.adminViewingControllerCheckCampaignParticipationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 뷰잉하기 캠페인 url 조회
         * @param {string} campaignUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminViewingControllerGetCampaignUrl(campaignUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetCampaignUrlOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminViewingControllerGetCampaignUrl(campaignUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminViewingApi.adminViewingControllerGetCampaignUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 회원 뷰잉하기 내역 조회
         * @param {boolean} isDeleted 삭제된 계정 포함
         * @param {string} [id] 
         * @param {string} [snsId] 
         * @param {string} [orderId] 
         * @param {AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum} [platformCategory] 
         * @param {AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum} [viewingBehavior] 
         * @param {AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum} [viewingCategory] 
         * @param {AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum} [pointFilterType] 
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminViewingControllerGetUserViewingHistorySortOrderEnum} [sortOrder] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminViewingControllerGetUserViewingHistory(isDeleted: boolean, id?: string, snsId?: string, orderId?: string, platformCategory?: AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum, viewingBehavior?: AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum, viewingCategory?: AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum, pointFilterType?: AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum, page?: number, limit?: number, sortOrder?: AdminViewingControllerGetUserViewingHistorySortOrderEnum, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetUserViewingHistoryOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminViewingControllerGetUserViewingHistory(isDeleted, id, snsId, orderId, platformCategory, viewingBehavior, viewingCategory, pointFilterType, page, limit, sortOrder, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminViewingApi.adminViewingControllerGetUserViewingHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 회원 뷰잉하기 포인트 누계 조회
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminViewingControllerGetUserViewingReport(userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetUserViewingReportOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminViewingControllerGetUserViewingReport(userId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminViewingApi.adminViewingControllerGetUserViewingReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminViewingApi - factory interface
 * @export
 */
export const AdminViewingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminViewingApiFp(configuration)
    return {
        /**
         * 
         * @summary 관리자 뷰잉 포인트 변경 API
         * @param {AdminViewingApiAdminChangeRewardPointRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangeRewardPoint(requestParameters: AdminViewingApiAdminChangeRewardPointRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminChangeRewardPointResponse> {
            return localVarFp.adminChangeRewardPoint(requestParameters.viewingTypeId, requestParameters.adminChangeViewingTypeRewardPointRequestBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 뷰잉하기 캠페인 참여 상태 확인
         * @param {AdminViewingApiAdminViewingControllerCheckCampaignParticipationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViewingControllerCheckCampaignParticipationStatus(requestParameters: AdminViewingApiAdminViewingControllerCheckCampaignParticipationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCheckCampaignParticipationStatusOkDto> {
            return localVarFp.adminViewingControllerCheckCampaignParticipationStatus(requestParameters.campaignUuid, requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 뷰잉하기 캠페인 url 조회
         * @param {AdminViewingApiAdminViewingControllerGetCampaignUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViewingControllerGetCampaignUrl(requestParameters: AdminViewingApiAdminViewingControllerGetCampaignUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetCampaignUrlOkDto> {
            return localVarFp.adminViewingControllerGetCampaignUrl(requestParameters.campaignUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 회원 뷰잉하기 내역 조회
         * @param {AdminViewingApiAdminViewingControllerGetUserViewingHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViewingControllerGetUserViewingHistory(requestParameters: AdminViewingApiAdminViewingControllerGetUserViewingHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetUserViewingHistoryOkDto> {
            return localVarFp.adminViewingControllerGetUserViewingHistory(requestParameters.isDeleted, requestParameters.id, requestParameters.snsId, requestParameters.orderId, requestParameters.platformCategory, requestParameters.viewingBehavior, requestParameters.viewingCategory, requestParameters.pointFilterType, requestParameters.page, requestParameters.limit, requestParameters.sortOrder, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 회원 뷰잉하기 포인트 누계 조회
         * @param {AdminViewingApiAdminViewingControllerGetUserViewingReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViewingControllerGetUserViewingReport(requestParameters: AdminViewingApiAdminViewingControllerGetUserViewingReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetUserViewingReportOkDto> {
            return localVarFp.adminViewingControllerGetUserViewingReport(requestParameters.userId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminChangeRewardPoint operation in AdminViewingApi.
 * @export
 * @interface AdminViewingApiAdminChangeRewardPointRequest
 */
export interface AdminViewingApiAdminChangeRewardPointRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminViewingApiAdminChangeRewardPoint
     */
    readonly viewingTypeId: number

    /**
     * 
     * @type {AdminChangeViewingTypeRewardPointRequestBodyDto}
     * @memberof AdminViewingApiAdminChangeRewardPoint
     */
    readonly adminChangeViewingTypeRewardPointRequestBodyDto: AdminChangeViewingTypeRewardPointRequestBodyDto
}

/**
 * Request parameters for adminViewingControllerCheckCampaignParticipationStatus operation in AdminViewingApi.
 * @export
 * @interface AdminViewingApiAdminViewingControllerCheckCampaignParticipationStatusRequest
 */
export interface AdminViewingApiAdminViewingControllerCheckCampaignParticipationStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerCheckCampaignParticipationStatus
     */
    readonly campaignUuid: string

    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerCheckCampaignParticipationStatus
     */
    readonly snsAccountUuid: string
}

/**
 * Request parameters for adminViewingControllerGetCampaignUrl operation in AdminViewingApi.
 * @export
 * @interface AdminViewingApiAdminViewingControllerGetCampaignUrlRequest
 */
export interface AdminViewingApiAdminViewingControllerGetCampaignUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetCampaignUrl
     */
    readonly campaignUuid: string
}

/**
 * Request parameters for adminViewingControllerGetUserViewingHistory operation in AdminViewingApi.
 * @export
 * @interface AdminViewingApiAdminViewingControllerGetUserViewingHistoryRequest
 */
export interface AdminViewingApiAdminViewingControllerGetUserViewingHistoryRequest {
    /**
     * 삭제된 계정 포함
     * @type {boolean}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly isDeleted: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly snsId?: string

    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly orderId?: string

    /**
     * 
     * @type {'instagram' | 'youtube' | 'facebook' | 'nblog' | 'googleplay' | 'appstore' | 'kakaochannel' | 'naverband' | 'web' | 'threads'}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly platformCategory?: AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum

    /**
     * 
     * @type {'like' | 'follow' | 'comment' | 'pagelike' | 'subscribe' | 'post' | 'install' | 'rating' | 'join' | 'friend' | 'event' | 'blog' | 'scrap' | 'bookmark' | 'notification'}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly viewingBehavior?: AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum

    /**
     * 
     * @type {'macro_click' | 'click' | 'install' | 'post' | 'etc' | 'auto' | 'plus'}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly viewingCategory?: AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum

    /**
     * 
     * @type {'earned' | 'deducted'}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly pointFilterType?: AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum

    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly limit?: number

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly sortOrder?: AdminViewingControllerGetUserViewingHistorySortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingHistory
     */
    readonly endDate?: string
}

/**
 * Request parameters for adminViewingControllerGetUserViewingReport operation in AdminViewingApi.
 * @export
 * @interface AdminViewingApiAdminViewingControllerGetUserViewingReportRequest
 */
export interface AdminViewingApiAdminViewingControllerGetUserViewingReportRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingReport
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingReport
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof AdminViewingApiAdminViewingControllerGetUserViewingReport
     */
    readonly endDate: string
}

/**
 * AdminViewingApi - object-oriented interface
 * @export
 * @class AdminViewingApi
 * @extends {BaseAPI}
 */
export class AdminViewingApi extends BaseAPI {
    /**
     * 
     * @summary 관리자 뷰잉 포인트 변경 API
     * @param {AdminViewingApiAdminChangeRewardPointRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminViewingApi
     */
    public adminChangeRewardPoint(requestParameters: AdminViewingApiAdminChangeRewardPointRequest, options?: RawAxiosRequestConfig) {
        return AdminViewingApiFp(this.configuration).adminChangeRewardPoint(requestParameters.viewingTypeId, requestParameters.adminChangeViewingTypeRewardPointRequestBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 뷰잉하기 캠페인 참여 상태 확인
     * @param {AdminViewingApiAdminViewingControllerCheckCampaignParticipationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminViewingApi
     */
    public adminViewingControllerCheckCampaignParticipationStatus(requestParameters: AdminViewingApiAdminViewingControllerCheckCampaignParticipationStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminViewingApiFp(this.configuration).adminViewingControllerCheckCampaignParticipationStatus(requestParameters.campaignUuid, requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 뷰잉하기 캠페인 url 조회
     * @param {AdminViewingApiAdminViewingControllerGetCampaignUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminViewingApi
     */
    public adminViewingControllerGetCampaignUrl(requestParameters: AdminViewingApiAdminViewingControllerGetCampaignUrlRequest, options?: RawAxiosRequestConfig) {
        return AdminViewingApiFp(this.configuration).adminViewingControllerGetCampaignUrl(requestParameters.campaignUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 회원 뷰잉하기 내역 조회
     * @param {AdminViewingApiAdminViewingControllerGetUserViewingHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminViewingApi
     */
    public adminViewingControllerGetUserViewingHistory(requestParameters: AdminViewingApiAdminViewingControllerGetUserViewingHistoryRequest, options?: RawAxiosRequestConfig) {
        return AdminViewingApiFp(this.configuration).adminViewingControllerGetUserViewingHistory(requestParameters.isDeleted, requestParameters.id, requestParameters.snsId, requestParameters.orderId, requestParameters.platformCategory, requestParameters.viewingBehavior, requestParameters.viewingCategory, requestParameters.pointFilterType, requestParameters.page, requestParameters.limit, requestParameters.sortOrder, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 회원 뷰잉하기 포인트 누계 조회
     * @param {AdminViewingApiAdminViewingControllerGetUserViewingReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminViewingApi
     */
    public adminViewingControllerGetUserViewingReport(requestParameters: AdminViewingApiAdminViewingControllerGetUserViewingReportRequest, options?: RawAxiosRequestConfig) {
        return AdminViewingApiFp(this.configuration).adminViewingControllerGetUserViewingReport(requestParameters.userId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum = {
    Instagram: 'instagram',
    Youtube: 'youtube',
    Facebook: 'facebook',
    Nblog: 'nblog',
    Googleplay: 'googleplay',
    Appstore: 'appstore',
    Kakaochannel: 'kakaochannel',
    Naverband: 'naverband',
    Web: 'web',
    Threads: 'threads'
} as const;
export type AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum = typeof AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum[keyof typeof AdminViewingControllerGetUserViewingHistoryPlatformCategoryEnum];
/**
 * @export
 */
export const AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum = {
    Like: 'like',
    Follow: 'follow',
    Comment: 'comment',
    Pagelike: 'pagelike',
    Subscribe: 'subscribe',
    Post: 'post',
    Install: 'install',
    Rating: 'rating',
    Join: 'join',
    Friend: 'friend',
    Event: 'event',
    Blog: 'blog',
    Scrap: 'scrap',
    Bookmark: 'bookmark',
    Notification: 'notification'
} as const;
export type AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum = typeof AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum[keyof typeof AdminViewingControllerGetUserViewingHistoryViewingBehaviorEnum];
/**
 * @export
 */
export const AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum = {
    MacroClick: 'macro_click',
    Click: 'click',
    Install: 'install',
    Post: 'post',
    Etc: 'etc',
    Auto: 'auto',
    Plus: 'plus'
} as const;
export type AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum = typeof AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum[keyof typeof AdminViewingControllerGetUserViewingHistoryViewingCategoryEnum];
/**
 * @export
 */
export const AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum = {
    Earned: 'earned',
    Deducted: 'deducted'
} as const;
export type AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum = typeof AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum[keyof typeof AdminViewingControllerGetUserViewingHistoryPointFilterTypeEnum];
/**
 * @export
 */
export const AdminViewingControllerGetUserViewingHistorySortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminViewingControllerGetUserViewingHistorySortOrderEnum = typeof AdminViewingControllerGetUserViewingHistorySortOrderEnum[keyof typeof AdminViewingControllerGetUserViewingHistorySortOrderEnum];
